import { c as _c } from "react/compiler-runtime";
import type { PropsWithStyles } from '@morpho-org/ui-v6/types';
import React, { memo, useMemo } from 'react';
import { gradients } from '@/styles/theme/theme-tokens';
import { ChartStatusRoot } from './ChartStatusRoot';
export interface ChartStatusNoDataProps extends PropsWithStyles {
  borderRadius: number;
  unit?: string;
  hideBorder?: boolean;
  hideYAxis?: boolean;
}
function ChartStatusNoData(t0) {
  const $ = _c(10);
  const {
    className,
    borderRadius,
    unit: t1,
    hideBorder,
    hideYAxis
  } = t0;
  const unit = t1 === undefined ? "" : t1;
  let t2;
  bb0: {
    if (unit === "$") {
      t2 = "$0";
      break bb0;
    }
    t2 = `0 ${unit}`;
  }
  const formattedUnit = t2;
  let t3;
  if ($[0] !== formattedUnit || $[1] !== hideYAxis) {
    t3 = !hideYAxis && <span className="text-3xs text-secondary-foreground absolute top-[48%] right-[10px]">{formattedUnit}</span>;
    $[0] = formattedUnit;
    $[1] = hideYAxis;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = {
      background: gradients["chart-blue-area-transparent"]
    };
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <div className="relative mt-auto h-1/2 w-full" style={t4}><div className="absolute my-auto h-[1px] w-full" style={{
        background: gradients["chart-blue-area"]
      }} /></div>;
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  let t6;
  if ($[5] !== borderRadius || $[6] !== className || $[7] !== hideBorder || $[8] !== t3) {
    t6 = <ChartStatusRoot className={className} borderRadius={borderRadius} hideBorder={hideBorder}>{t3}{t5}</ChartStatusRoot>;
    $[5] = borderRadius;
    $[6] = className;
    $[7] = hideBorder;
    $[8] = t3;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  return t6;
}
export default memo(ChartStatusNoData);